var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',[_vm._v("Prestatario")]),_vm._l((_vm.labels),function(label){return _c('th',{key:label},[_vm._v(_vm._s(label))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }